module.exports = __webpack_public_path__ + "img/logo.76c36b6.png";